/*
 * @Description: 注意使用useCreateModal时，组件内无法使用useRoute
 * @Date: 2025-05-26 19:47:10
 */
import { FunctionCode } from '@cTypes/user';
import { useRoute } from 'vue-router';

export const useRouteMeta = () => {
  const route = useRoute();
  const meta = route.meta as {
    functionCode: FunctionCode;
  };
  return meta;
};
